import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import calendarReducer from "./calendarSlice";
import notificationsReducer from "./notificationSlice";
import processingPostsReducer from "./processingPostsSlice";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
import sessionStorage from "redux-persist/lib/storage/session"; // sessionStorage

const authPersistConfig = {
    key: "auth",
    storage,
    // Persist everything except impersonation session state (which lives in
    // sessionStorage) and transient flags. Keeping the impersonation token out of
    // localStorage is explicit here, not an accident of a whitelist that matched
    // no state key.
    blacklist: [
        "impersonationToken",
        "sessionId",
        "impersonatedUser",
        "originalUser",
        "isImpersonating",
        "wasAdminView",
        "impersonationExpired",
        "loading",
        "error",
    ],
};

const calendarPersistConfig = {
    key: "calendar",
    storage: sessionStorage,
    whitelist: [
        "selectedView",
        "selectedListingAddress",
        "selectedPlatform",
        "selectedApprovalStatus",
    ],
};

const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    calendar: persistReducer(calendarPersistConfig, calendarReducer),
    notifications: notificationsReducer,
    processingPosts: processingPostsReducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
